import { AuditLogSchema } from "@redotech/account-common/audit-log";
import * as z from "zod";

export const getAuditLog = {
  name: "getAuditLog" as const,
  input: z.object({ _id: z.string() }),
  output: AuditLogSchema.nullable(),
};

export const getAuditLogs = {
  name: "getAuditLogs" as const,
  input: z.object({
    type: z.string().optional(),
    createdAt: z.tuple([z.date().nullable(), z.date().nullable()]).optional(),
    team: z.string().optional(),
    user: z.string().optional(),
    Resource: z.string().optional(),
    path: z.string().optional(),
    offset: z.number().optional(),
  }),
  output: z.object({
    auditLogs: z.array(AuditLogSchema),
    nextOffset: z.number().nullable(),
  }),
};
